import { PaymentButtonWidgetContent } from './PaymentButtonWidgetContent';
import type { PaymentButtonWidgetProps } from './usePaymentButtonWidget';

export const PaymentButtonWidget = ({
  hooks,
  data,
  handlers,
  externalHooks,
  version,
  isCustomer,
}: PaymentButtonWidgetProps) => {
  return (
    <PaymentButtonWidgetContent
      data={data}
      handlers={handlers}
      hooks={hooks}
      externalHooks={externalHooks}
      version={version}
      isCustomer={isCustomer}
    />
  );
};
